<template>
  <div>
    <div id="admin-preloader" v-if="loading">
      <div id="admin-loader-text">Loading</div>
      <div id="admin-loader"></div>
    </div>
    <div id="admin-preloader" v-if="loading1">
      <div id="admin-loader-text">Updating</div>
      <div id="admin-loader"></div>
    </div>
    <div id="admin-preloader" v-if="loading2">
      <div id="admin-loader-text">Deleting</div>
      <div id="admin-loader"></div>
    </div>
    <!-- <div class="admin-load" >

<div class="admin-loader" id="admin-loader"></div>
<div class="admin-loader" id="admin-loader2"></div>
<div class="admin-loader" id="admin-loader3"></div>
<div class="admin-loader" id="admin-loader4"></div>

<span id="admin-text">LOADING...</span>

   </div> -->
    <!-- <div class="my-add-spinner" v-if="loading">
        <div class="my-add-spinner-text">Loading</div>
        <div class="my-add-spinner-sector my-add-spinner-sector-red"></div>
        <div class="my-add-spinner-sector my-add-spinner-sector-blue"></div>
        <div class="my-add-spinner-sector my-add-spinner-sector-green"></div>
      </div> -->

    <!-- <div v-if="loading1" class="mx-auto pt-5 col-12 col-sm-8 col-md-6">
    <div class="spinner">
        <div class="spinner-text">Updating</div>
        <div class="spinner-sector spinner-sector-red"></div>
        <div class="spinner-sector spinner-sector-blue"></div>
        <div class="spinner-sector spinner-sector-green"></div>
      </div>
 </div> -->
    <div class="" v-if="changed">
      <div v-if="$store.state.systemUser.role !== 'Kitchen Staff'" class="m-auto text-right pt-3">
        <el-button
          @click="dialogFormVisible2 = true"
          type="primary"
          size="medium"
        >
          <i class="el-icon-plus mr-2"></i>Add KOT</el-button
        >
      </div>

      <div class="col-sm-12 col-md-8 col-lg-6 m-auto pl-4">
        <el-dialog
          title="Add KOT"
          :visible.sync="dialogFormVisible2"
          :width="width"
        >
          <!-- <h4 class="text-center pt-4 pb-3">Add Expense</h4> -->
          <el-card shadow="always" style="background-color: #f5f7fa">
            <KOTItemTable :KOTItemData="kotItems" :tableNo="tableNo" :kotNote="kotNote" :method="'create'" :allProducts="allProducts" />
          </el-card>
        </el-dialog>
        <el-dialog
          title="Update KOT"
          :visible.sync="dialogFormVisible"
          :width="width"
          @close="BUS.$emit('kotdialogClosed')"
          @open="BUS.$emit('kotdialogOpen', kot)"
        >
          <!-- <h4 class="text-center pt-4 pb-3">Add Expense</h4> -->
          <el-card shadow="always" style="background-color: #f5f7fa">
            <KOTItemTable :KOTItemData="kot.items" :tableNo="kot.table" :method="'update'" :kotNote="kot.note" :kotid="kot.id" :allProducts="allProducts" />
          </el-card>
        </el-dialog>
      </div>

      <b-container class="col-lg-10 mt-5">
        <h3 class="text-info text-center pt-4 my-4">Today's KOTs</h3>
        <!-- User Interface controls -->
        <b-row>
          <!-- <b-col sm="4" class="my-1">
        <b-form-group  label="" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" placeholder="Search" />
            <b-input-group-append>
              <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col> -->
          <b-col sm="5" class="my-1">
            <b-form-group label="" class="mb-0">
              <b-input-group>
                <b-form-select v-model="sortBy" :options="sortOptions">
                  <option slot="first" :value="null">Sort By</option>
                </b-form-select>
                <b-form-select
                  :disabled="!sortBy"
                  v-model="sortDesc"
                  slot="append"
                >
                  <option :value="false">Asc</option>
                  <option :value="true">Desc</option>
                </b-form-select>
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col sm="3" class="my-1">
            <b-form-group horizontal class="mb-0">
              <b-form-select v-model="perPage">
                <option disabled>per page</option>
                <option :value="10">10</option>
                <option :value="20">20</option>
                <option :value="40">40</option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <KOTPrint style="display: none" id="printKOT" :kotNo="printKot.kotNo" :note="printKot.note" :table="printKot.table" :date="printKot.date" :products="printKot.items"  />
        <KOTPrint style="display: none" id="printBOT" :kotNo="printBot.kotNo" :note="printBot.note" :table="printBot.table" :date="printBot.date" :products="printBot.items"  />
        <!-- Main table element -->
        <el-card style="overflow-x: scroll;" shadow="always">
          <b-table
            show-empty
            stacked="sm"
            :items="items"
            :fields="fields"
            :hover="true"
            head-variant="dark"
            :current-page="currentPage"
            :per-page="perPage"
            :empty-text="emptyText"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            @filtered="onFiltered"
            class="mt-4"
          >
            <template slot="index" slot-scope="data">
              {{ data.index + 1 }}
            </template>
            <template slot="name" slot-scope="row">
              <b-media>
                <b-img
                  slot="aside"
                  src="https://lorempixel.com/125/125/technics/8/"
                  width="64"
                  height="64"
                  alt="image"
                />
                <h6 class="mt-4">{{ row.value }}</h6>
              </b-media>
            </template>
            <template slot="category" slot-scope="row" class="mt-4">
              <div class="row mt-4">{{ row.value }}</div>
            </template>

            <template slot="status" slot-scope="row">
              <el-select
                v-model="row.item.status"
                @change="upOrder(row.item.id, row.item.status)"
                size="mini"
                style="width: 160px"
                placeholder="Order Status"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </template>

            <template slot="actions" slot-scope="row">
              <div class="btn-group" role="group" aria-label="Basic example">
                <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->

                <a
                  size="sm"
                  @click.stop="row.toggleDetails"
                  class="btn btn-sm btn-info text-white"
                >
                  View Items
                </a>
                <a
                  v-if="$store.state.systemUser.role !== 'Kitchen Staff'"
                  size="sm"
                  @click.stop="showUpdateKOT(row.item)"
                  class="btn btn-sm btn-primary text-white"
                >
                  Update
                </a>
                <router-link
                  :to="{
                    name: 'createinvoice',
                    query: { kot: row.item.kotNo, },
                  }"
                  class="btn btn-sm btn-warning text-white"
                >
                  Invoice
                </router-link>
                <a
                  v-if="$store.state.systemUser.role !== 'Kitchen Staff'"
                  size="sm"
                  @click="open(row.item.id, row.item.status)"
                  class="btn btn-sm btn-danger text-white"
                >
                  Delete
                </a>
                <!-- <a
                  v-if="$store.state.systemUser.role !== 'Kitchen Staff'"
                  size="sm"
                  @click="managePrint( row.item, 'both')"
                  class="btn btn-sm btn-secondary text-white"
                >
                  Print
                </a> -->
                <a
                  v-if="$store.state.systemUser.role !== 'Kitchen Staff'"
                  size="sm"
                  @click="managePrint( row.item, 'kot')"
                  class="btn btn-sm btn-secondary text-white"
                >
                  Print KOT
                </a>
                <a
                  v-if="$store.state.systemUser.role !== 'Kitchen Staff' &&
                  row.item.items.filter(itm => itm.cat === 'Beverage' || itm.cat === 'Beverages' || itm.cat.toLowerCase() === 'bot').length > 0"
                  size="sm"
                  @click="managePrint( row.item, 'bot')"
                  class="btn btn-sm btn-secondary text-white"
                >
                  Print BOT
                </a>
              </div>
            </template>

            <template slot="row-details" slot-scope="row">
              <b-card>
                <ul>
                  <!-- <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value}}</li> -->
                  <!-- <template class="" v-for="(item, key) in row.item" >
              <div :key="key"> -->
                  <!-- <h5 class="text-center text-info">Customer Details</h5>
                  <li class="my-1 mr-2">
                    Customer Name:
                    <span class="ml-2">{{ row.item.cusname }}</span>
                  </li>
                  <li class="my-1 mr-2">
                    Email: <span class="ml-2">{{ row.item.cusemail }}</span>
                  </li>
                  <li class="my-1 mr-2">
                    Telephone: <span class="ml-2">0{{ row.item.telno }}</span>
                  </li>
                  <li class="my-1 mr-2">
                    Address: <span class="ml-2">{{ row.item.address }}</span>
                  </li>
                  <li class="my-1 mr-2">
                    Cart Total Rs:
                    <span class="ml-2">{{ row.item.total }}</span>
                  </li> -->
                  <!-- </div>
            </template> -->
                </ul>
                <div> <span>Note: </span> {{row.item.note}}</div>
                <h5 class=" text-info my-4">Ordeded Items</h5>
                <div class="row">
                  <template class="">
                    <div class="col-12 col-md-8" style="">
                      <!-- <img class="card-img-top" :src="item.image" alt="image" /> -->
                        <el-table ref="singleTable" :data="row.item.items" highlight-current-row style="
                            {
                              overflow-x: scroll;
                              width: 800px;
                              margin: 0 auto;
                            }
                          ">
                        <el-table-column type="index" width="50"> </el-table-column>

                        <el-table-column width="250" property="serial" label="Item">
                          <template slot-scope="scope">
                            {{ scope.row.item }}
                          </template>
                        </el-table-column>
                        <el-table-column width="150" property="quantity" label="Quantity">
                          <template slot-scope="scope">
                            {{ scope.row.quantity }}
                          </template>
                        </el-table-column>

                      </el-table>

                    </div>
                  </template>
                </div>
              </b-card>
            </template>
          </b-table>
        </el-card>
        <b-col md="6" class="my-1">
          <b-pagination
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="currentPage"
            class="my-0"
          />
        </b-col>
        <!-- Info modal -->
        <!-- <b-modal id="modalInfo" @hide="resetModal" :title="modalInfo.title" ok-only>
      <pre>{{ modalInfo.content }}</pre>
       <AddProduct/>
    </b-modal> -->
      </b-container>
    </div>
  </div>
</template>

<script>
import db from "../../config/FirebaseInit";
import firebase from "firebase/app";
import KOTItemTable from './KOTItemTable.vue'
import KOTPrint from './InvoiceTemplates/KOTPrint.vue'
import { bus } from "../../main";
const items = [];
export default {
  name: "kot",
   components: {
    KOTItemTable,
    KOTPrint
  },
  data() {
    return {
      BUS: bus,
      emptyText: "Loading Records...",
      items: [],
      fields: [
        "index",
        //  { key: 'id', label: 'Order id', sortable: true },
        { key: "kotNo", label: "KOT No", sortable: true },
        { key: "date", label: "Date", sortable: true },
        { key: "table", label: "Table", sortable: true },
        { key: "createdBy", label: "Created By", sortable: true },
        { key: "status", label: "Status", sortable: true },
        { key: "invoice", label: "Invoice No", sortable: true },
        { key: "actions", label: "Actions" },
      ],
      options: [
        {
          value: "Pending",
          label: "Pending",
        },
        {
          value: "Processing",
          label: "Processing",
        },
        {
          value: "Cooked",
          label: "Cooked",
        },
      ],
      serviceStaffOptions: [
        {
          value: "Served",
          label: "Served",
        },
        {
          value: "Cancelled",
          label: "Cancelled",
        },
      ],
      productId: "",
      currentPage: 1,
      perPage: 10,
      totalRows: items.length,
      pageOptions: ["Per Page", 5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      isLoggedIn: false,
      currentUser: false,
      modalInfo: { title: "", content: "" },
      loading: false,
      loading1: false,
      loading2: false,
      changed: false,
      shops: [],
      orders: "",
      dialogFormVisible2:false,
      dialogFormVisible:false,
      kotItems: [],
      tableNo:'',
      width: '',
      kotNote: "",
      kot: '',
      printKot: '',
      printBot: '',
      allProducts: []
    };
  },

  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
  mounted() {
    bus.$on("kotSaved", (data) => {
      this.dialogFormVisible2 = false;
     this.dialogFormVisible = false;
    })
  },
  methods: {
    managePrint(item, type) {
      const kotItems = item.items.filter(itm => itm.cat !== 'Beverage' && itm.cat !== 'Beverages' && itm.cat.toLowerCase() !== 'bot')
      const botItems = item.items.filter(itm => itm.cat === 'Beverage' || itm.cat === 'Beverages' || itm.cat.toLowerCase() === 'bot')
      const kot = Object.assign(JSON.parse(JSON.stringify(item)), {items: kotItems});
      const bot = Object.assign(JSON.parse(JSON.stringify(item)), {items: botItems});
      console.log("kotItems",kotItems,botItems,kot,bot)
      if (type == 'both') {
        this.print(kot,'printKOT')
        if (botItems && botItems.length > 0) {
          setTimeout(() => { this.print(bot,'printBOT'), 500})
        }
      }
      if (type == 'kot') this.print(kot,'printKOT')
      if (type == 'bot') this.print(bot,'printBOT')
    },
    print(item,printId) {
      let delay = 200;
      if (printId=== 'printBOT') delay = 1000
      if (printId === 'printKOT') this.printKot = item
      if (printId === 'printBOT') this.printBot = item
      console.log('printId',printId,item,this.printKot )
      setTimeout(() => {
        var mywindow = window.open("", "PRINT", "fullscreen=yes");

        mywindow.document.write(
          "<html><head><title>" + document.title + "</title>"
        );
        mywindow.document.write(
          `<link rel="stylesheet" href="../../../../static/pos.css" type="text/css" />`
        );

        mywindow.document.write("</head><body >");
        mywindow.document.write(document.getElementById(printId).innerHTML);
        mywindow.document.write("</body></html>");

        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/

        mywindow.print();
        return true;
      }, delay);

      // if (!this.showPrintPopup) {
      //   mywindow.close();
      // }
    },
    showUpdateKOT(item) {
      this.kot = item;
      this.dialogFormVisible = true;
    },
    open(id, status) {
      this.$confirm(
        "This will permanently delete the item. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          if (status === "Pending" || status === "Processing") {
            return this.$notify({
              title: "Cannot Delete",
              message: "Order status is pending or processing",
              duration: 0,
              type: "error",
            });
          }
          this.deleteOrder(id, status);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled",
          });
        });
    },
    // open2(id) {
    //   this.$confirm('This will change the order status. Continue?', 'Warning', {
    //     confirmButtonText: 'OK',
    //     cancelButtonText: 'Cancel',
    //     type: 'warning',
    //     center: true
    //   }).then(() => {
    //     this.upOrder(id)
    //   }).catch(() => {
    //     this.$message({
    //       type: 'info',
    //       message: 'Change canceled'
    //     });
    //   });
    // },
    open3() {
      this.$notify.info({
        title: "Success",
        type: "success",
        message: "KOT status is updated",
      });
    },
    upOrder(id, status, refid) {
      this.$store.state.secondaryDatabase
        .collection("kot")
        .doc(id)
        .update({
          status: status,
        })
        .then(() => {
          this.open3();

        })
        .catch((error) => alert(error));
    },
    deleteOrder(id, status) {
      this.loading2 = true;
      this.changed = false;
      this.$store.state.secondaryDatabase
        .collection("kot")
        .doc(id)
        .delete()
        .then(() => {
          //console.log('item deleted', id)
          var newitems = this.items.filter((item) => {
            //console.log('filfkkk')
            return item.id !== id;
          });
          this.items = newitems;
          this.totalRows = this.items.length;
          this.loading2 = false;
          this.changed = true;
          if (this.items.length == 0) {
            this.emptyText = "There are no records to show";
          }
          //console.log(this.items)

        })
        .catch((error) => alert(error));
    },

    info(item, index, button) {
      this.modalInfo.title = `Row index: ${index}`;
      this.modalInfo.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    resetModal() {
      this.modalInfo.title = "";
      this.modalInfo.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getId(item) {
      //console.log('getId fun invoked')
      this.productId = item.id;
      //console.log(this.productId)
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    backToTop: function () {
      $("html,body").stop().animate(
        {
          scrollTop: 0,
        },
        "fast",
        "swing"
      );
    },
  },
  created() {
    if (screen.width > 767) {
      this.width = "50%";
    } else {
      this.width = "85%";
    }
    //  if(firebase.auth().currentUser) {
    //       this.isLoggedIn = true;
    //       this.currentUser = firebase.auth().currentUser.email;
    //   }
    //  db.collection('shops').where('owner', '==', firebase.auth().currentUser.uid).get()
    //   .then(querySnapshot => {
    //   querySnapshot.forEach(doc => {
    //     const data = {
    //       'id': doc.id,
    //     }
    //     this.shops.push(data)
    //   })
    this.backToTop();
    this.loading = true;
    this.changed = false;

    if (this.$store.state.allProducts != undefined && this.$store.state.allProducts.length !== 0) {
      this.allProducts = this.$store.state.allProducts;
    } else if (this.$store.state.allProducts.length === 0) {
      this.$store.state.secondaryDatabase
        .collection("products")
        .where("owner", "==", firebase.auth().currentUser.uid)
        .get()
        .then((querySnapshot) => {
          var newitems = [];
          querySnapshot.forEach((doc) => {
            // //console.log('this.items.length is', state.items.length)
            const data = {
              id: doc.id,
              name: doc.data().name,
              barcode: doc.data().barcode,
              altertQunty: doc.data().altertQunty,
              category: doc.data().cat,
              brand: doc.data().brand,
              price: doc.data().disprice,
              subcategory: doc.data().subcat,
              desc: doc.data().desc,
              priceList: doc.data().priceList,
              totalQnty: 0,
              rack: doc.data().rack || '',
              img: doc.data().img,
              // 'otherimgs': doc.data().otherimgs,
            };
            // const bytes = sizeof(doc.data());
            // console.log("size of doc", bytes, doc.data().name);
            newitems.push(data);
            this.allProducts = newitems;
            this.$store.state.allProducts = newitems;

          });
          if (this.items.length == 0) {
            this.emptyText = "There are no records to show";
          }
          this.loading1 = false;
          this.changed = true;
          console.log('kot', newitems)
          //console.log('state.items',this.$store.state.items)
        });
    }

    const docRef = this.$store.state.secondaryDatabase.collection("kot");
    let firestoreQuery = docRef;
    const start = new Date();
    start.setHours(0, 0, 0, 0);
    console.log(start);

    const end = new Date();
    end.setHours(23, 59, 59, 999);
    console.log(end);
    firestoreQuery = firestoreQuery.where(
      "date",
      ">=",
      firebase.firestore.Timestamp.fromDate(start)
    );
    firestoreQuery = firestoreQuery.where(
      "date",
      "<=",
      firebase.firestore.Timestamp.fromDate(end)
    );
    if (this.$store.state.systemUser.role === 'Service Staff' ) {
      firestoreQuery = firestoreQuery.where("user", "==", this.$store.state.systemUser.id)
      this.options = this.serviceStaffOptions;
    }
    if (this.$store.state.systemUser.role === 'Kitchen Staff' ) {
      console.log("Kitchen Staff",this.$store.state.systemUser.role);
      // firestoreQuery.where("user", "==", this.$store.state.systemUser.id)
      firestoreQuery = firestoreQuery.where("status", "in", ['Received', 'Pending', 'Processing'])
    }
    let pageRendered = false;
    firestoreQuery
      .where("store", "==", this.$store.state.selectedStore)
      .orderBy("date", "desc")
      .onSnapshot((querySnapshot) => {
        this.items = [];
        if (pageRendered) {
          querySnapshot.docChanges().forEach((change) => {
              if (change.type === "added" && this.$store.state.systemUser.role === 'Kitchen Staff') {
                  this.$notify.info({
                    title: "New KOT",
                    type: "success",
                    duration: 0,
                    message: "New KOT is Added",
                  });
              }
              if (change.type === "modified") {
                  console.log("Modified city: ", change.doc.data());
                  this.$notify.info({
                    title: "KOT Updated",
                    type: "warning",
                    duration: 0,
                    message: `KOT ${change.doc.data().kotNo} is Updated`,
                  });
              }
              if (change.type === "removed") {
                  // console.log("Removed city: ", change.doc.data());
              }
          });
        }
        querySnapshot.forEach((doc) => {
          const data = {
            id: doc.id,
            date: doc.data().date,
            note: doc.data().note,
            items: doc.data().items,
            table: doc.data().table,
            status: doc.data().status,
            createdBy: doc.data().createdBy,
            kotNo: doc.data().kotNo,
            invoice: doc.data().invoice || '-',
          };
          if (data.date) data.date = data.date.toDate().toLocaleString();
          this.items.push(data);
          this.totalRows = this.items.length;
        });
        pageRendered = true;
        if (this.items.length == 0) {
          this.emptyText = "There are no records to show";
        }
        this.loading = false;
        this.changed = true;
      }, (error) => {
          console.log(error)
      });

    // })
  },
};
</script>

<style scoped>
@import url("~@/assets/admin/css/admin-loader.css");
</style>




// WEBPACK FOOTER //
// src/components/admin/KOT.vue